import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LanguageProvider } from "@/contexts/LanguageContext";

const Index = lazy(() => import("./pages/Index"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

// Success handler component
const SuccessHandler = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check if the form was successfully submitted
    if (
      window.location.hash === "#success" ||
      searchParams.get("success") === "true" ||
      document.referrer.includes("?success=true")
    ) {
      toast.success("Tack för visat intresse! Vi kontaktar dig inom kort.", {
        duration: 5000,
      });

      // Clear the success parameter from the URL
      if (searchParams.get("success") === "true") {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete("success");
        window.history.replaceState(
          {},
          "",
          window.location.pathname + (newParams.toString() ? `?${newParams.toString()}` : "")
        );
      }
    }
  }, [searchParams]);

  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              {/* Advanced page is temporarily disabled; keep code but redirect visitors */}
              <Route path="/advanced" element={<Navigate to="/" replace />} />
              <Route path="/Advanced" element={<Navigate to="/" replace />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <SuccessHandler />
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
